<template>
    <v-row class="my-1 py-2" no-gutters>
        <v-col md="2"> </v-col>
        <v-col :md="isForeign ? 3 : 5"><span class="font-weight-bold">Totals</span></v-col>
        <v-col>
            <span class="font-weight-bold">{{ formatNumber(value.base_debit, round) }}</span>
        </v-col>
        <v-col>
            <span class="font-weight-bold">{{ formatNumber(value.base_credit, round) }}</span>
        </v-col>
        <v-col v-if="isForeign">
            <span class="font-weight-bold">{{ formatNumber(value.trans_debit, round) }}</span>
        </v-col>
        <v-col v-if="isForeign">
            <span class="font-weight-bold">{{ formatNumber(value.trans_credit, round) }}</span>
        </v-col>
        <v-col md="2">
            <span class="font-weight-bold" :class="{'error--text': !isBalanced, 'success--text': isBalanced}">{{ formatNumber(difference, round) }}</span>
        </v-col>
    </v-row>
</template>

<script>
// Third Parties
import { formatNumber } from "accounting";
// Services

export default {
    components: {},
    name: "JournalEntrySummary",
    props: {
        index: Number,
        value: Object,
        baseCurrency: Object,
        journalCurrency: Object,
    },
    data() {
        return {
            round: 2
        };
    },
    computed: {
        isForeign() {
            return this.baseCurrency != this.journalCurrency;
        },
        difference() {
            return this.value.base_debit - this.value.base_credit;
        },
        isBalanced() {
            return this.difference == 0;
        }
    },
    watch: {},
    methods: {
        formatNumber,
    },
    mounted() {},
};
</script>
